import React from "react";

import PropTitreSection from "../components/PropTitreSection";
import Carousel from "../components/Carousel";

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faDatabase, faCode, faChalkboard, faMagnifyingGlass} from "@fortawesome/free-solid-svg-icons";
// Si vous souhaitez ajouter d'autres icônes pour mieux représenter les nouvelles catégories,
// vous pouvez les importer ici, par exemple :
// import { faShieldHalved, faWrench } from "@fortawesome/free-solid-svg-icons";

import "../styles/SectionCompetence.css"

function SectionCompetences(){
    return(
        <section id="sectionCompetence" className="sectionCompetence">
            <PropTitreSection
                titreSection="Mes compétences"
                soustitreSection="Plongez vous dans mes compétences et découvrez comment nous pouvons collaborer pour donner 
                vie à vos projets web !"
            />
                <div className="paragrapheCompetence">
                    <div className="competences">
                    
                        <div className="competence">
                        <div className="titreTechno">
                                <h3 className="titreCompentence">Front-end :</h3>
                                <div className="technoCompetence">Html, Css, javascript, React</div>
                            </div>
                            <div className="divCercle">
                                <div className="cercle">
                                    <FontAwesomeIcon icon={faChalkboard} className="icone" />
                                </div>
                            </div>
                        </div>

                        <div className="competence">
                            <div className="titreTechno">
                                <h3 className="titreCompentence">Back-end :</h3>
                                <div className="technoCompetence">Java, Spring Boot, Spring Gateway</div>
                            </div>
                            <div className="divCercle">
                                <div className="cercle">
                                    <FontAwesomeIcon icon={faCode} className="icone" />
                                </div>
                            </div>
                        </div>

                        <div className="competence">
                            <div className="titreTechno">
                                <h3 className="titreCompentence">Sécurité :</h3>
                                <div className="technoCompetence">Spring Security, Bcrypt, Dotenv</div>
                            </div>
                            <div className="divCercle">
                                <div className="cercle">
                                    <FontAwesomeIcon icon={faCode} className="icone" />
                                </div>
                            </div>
                        </div>

                        <div className="competence">
                        <div className="titreTechno">
                                <h3 className="titreCompentence">Base de donnée :</h3>
                                <div className="technoCompetence">SQL (mySql et postgreSql) et NoSql (MongoDB)</div>
                            </div>
                            <div className="divCercle">
                                <div className="cercle">
                                    <FontAwesomeIcon icon={faDatabase} className="icone" />
                                </div>
                            </div>
                        </div>

                        <div className="competence">
                        <div className="titreTechno">
                                <h3 className="titreCompentence">Tests :</h3>
                                <div className="technoCompetence">Unitaires (JUnit, Mockito), Intégration</div>
                            </div>
                            <div className="divCercle">
                                <div className="cercle">
                                    <FontAwesomeIcon icon={faDatabase} className="icone" />
                                </div>
                            </div>
                        </div>
                        
                         <div className="competence">
                        <div className="titreTechno">
                                <h3 className="titreCompentence">DevOps & CI/CD :</h3>
                                <div className="technoCompetence">GitHub Actions, Déploiement</div>
                            </div>
                            <div className="divCercle">
                                <div className="cercle">
                                    <FontAwesomeIcon icon={faMagnifyingGlass} className="icone" />
                                </div>
                            </div>
                        </div>

                        <div className="competence">
                        <div className="titreTechno">
                                <h3 className="titreCompentence">Référencement et SEO :</h3>
                                <div className="technoCompetence">Wave, Google Lighthouse, GT Metrix</div>
                            </div>
                            <div className="divCercle">
                                <div className="cercle">
                                    <FontAwesomeIcon icon={faMagnifyingGlass} className="icone" />
                                </div>
                            </div>
                        </div>

                    </div>
                    <div className="divCarousel">
                        <Carousel />
                    </div>
                </div>

        </section>
    );
}

export default SectionCompetences;